import { Exclude, Transform, Type } from 'class-transformer';

import { booleanTransform } from '../utils/helper';
import { InsDate, InsModDate } from './date.model';
import { Feature } from './feature.model';

export class Role extends InsModDate {
	id!: number;
	rolename!: string;
	description?: string;
	@Transform(booleanTransform)
	editable?: boolean;

	// @Exclude({ toPlainOnly: true })
	slug?: string;

	@Exclude()
	features?: RoleFeature[];
	@Exclude()
	showdetails?: boolean;
}

export class RoleFeature extends InsDate {
	id!: number;
	rid!: number;
	fid!: number;
	@Type(() => Feature)
	feature?: Feature;
}
